import React, { useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";

export const SimCancelOrder = ({ order, onClose, onDone }) => {
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  const go = async () => {
    setBusy(true);
    try { await api.post(`/sim-stock/orders/${order.session_id}/cancel`, { reason }); toast.success("Ordine annullato"); window.dispatchEvent(new Event("sim-changed")); onDone(); }
    catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Annullamento non riuscito"); }
    finally { setBusy(false); }
  };
  return <div className="flex flex-wrap items-center gap-2 w-full" data-testid={`sim-cancel-form-${order.session_id}`}>
    <Input className="flex-1 min-w-[12rem]" placeholder="Motivo (es. voglio ordinarne di più)" value={reason} onChange={(e) => setReason(e.target.value)} data-testid={`sim-cancel-reason-${order.session_id}`} />
    <Button size="sm" variant="destructive" onClick={go} disabled={busy || reason.trim().length < 3} data-testid={`sim-cancel-confirm-${order.session_id}`}>{busy ? "Annullo…" : "Conferma annullamento"}</Button>
    <Button size="sm" variant="ghost" onClick={onClose} data-testid={`sim-cancel-back-${order.session_id}`}>Indietro</Button>
  </div>;
};
